module.exports = __webpack_public_path__ + "img/critical-resend-message.76b92541.svg";